const ReferenceData = {
    ACCEPT_OAUTH_CONSENT:
        "/participant-web-services/rest/nonauth/oauth2/loginCustomization/acceptConsentRequest",
    CALL_AUTHENTICATE: "/participant-web-services/rest/nonauth/authenticate",
    CALL_AUTHENTICATELITE: "/participant-web-services/rest/nonauth/authenticateLite",
    CALL_AUTHENTICATEPART: "/api/auth/multiauth/noauth/authenticate",
    CALL_AUTHENTICATE_TOKEN: "/participant-web-services/rest/nonauth/authenticateToken",
    CALL_CHALLENGE_SMS_AUTH: "/api/credential/challengeSmsFreemium",
    CALL_AUTHENTICATE_SMS_AUTH: "/api/credential/authenticateSmsFreemium",
    CHALLENGE_RESET_PASSWORD_FREEMIUM: "/api/credential/challengeResetPasswordFreemium",
    CALL_CHALLENGE_PHONE_AUTH: "/api/credential/challengePhoneFreemium",
    CALL_AUTHENTICATE_PHONE_AUTH: "/api/credential/authenticatePhoneFreemium",
    CLEAR_LANGUAGE_COOKIES: "/participant-web-services/rest/nonauth/clearLanguageCookies",
    CLEAR_SPANISH_LANGUAGE_COOKIES:
        "/participant-web-services/rest/nonauth/clearSpanishLanguageCookies",
    GET_AUTH_DATA: "/participant-web-services/rest/nonauth/isAuthenticated",
    GET_ACCOUNT_DETAILS: "/participant-web-services/rest/accounts/account/{individualId}/{groupId}",
    GET_ACCOUNT_SUMMARY: "/participant-web-services/rest/accounts/summary",
    GET_DEFAULT_CUSTOMIZATION: "customizations/Default/AccountsDefaultCustomization.json",
    GET_DELIVERY_OPTIONS: "/participant-web-services/rest/partialauth/mfa/deliveryOptions",
    GET_DELIVERY_OPTIONS_BY_IND_ID:
        "/participant-web-services/rest/partialauth/mfa/deliveryOptionsByIndId/{indId}/{dbName}",
    GET_ELIGIBILITY_LITE: "/participant-web-services/rest/home/eligibilityLite",
    GET_OAUTH_LOGIN_URL: "/participant-web-services/rest/nonauth/oauth2/loginCustomization",
    GET_OAUTH_CONSENT_URL:
        "/participant-web-services/rest/nonauth/oauth2/loginCustomization/getConsentRequest",
    GET_PRELOGIN_ACCU: "customizations/{accu}/{accu}{suffixPath}",
    GET_PRELOGIN_BULLETIN:
        "/participant-web-services/rest/nonauth/bulletins/site?accu={accu}&primaryDBFlag={primaryDBFlag}",
    GET_PRELOGIN_CONTACT_INFO:
        "/participant-web-services/rest/nonauth/getPreLoginContactInfoByAccu/{accu}/{accuSpecificPrimDb}/{portalType}",
    GET_PRIMARY_PLAN: "/participant-web-services/rest/accounts/primaryPlan",
    GET_PSC_PATH: "/participant-web-services/rest/nonauth/getPSCPath",
    IDENTIFY_USER_FREEMIUM: "/api/login/identifyUserFreemium",
    PARTICIPANT_LOGIN_INFORMATON:
        "/participant-web-services/rest/partialauth/retirementIncomeView/participantLoginInformation",
    PARTICIPANT_INITIAL_DATA:
        "/participant-web-services/rest/retirementIncomeView/getHouseholdInitData",
    REGISTER_WITHOUT_PIN:
        "/participant-web-services/rest/nonauth/registration/registrationWithoutPin",
    REGISTER_WITH_PIN: "/participant-web-services/rest/nonauth/registration/registrationWithPin",
    REGISTER_WITH_GROUP_PASSWORD:
        "/participant-web-services/rest/nonauth/npdi/validateGaIDAndNPDIPin",
    REGISTRATION_SUMMARY: "/participant-web-services/rest/partialauth/registrationSummary",
    REJECT_OAUTH_CONSENT:
        "/participant-web-services/rest/nonauth/oauth2/loginCustomization/rejectConsentRequest/",
    RESET_ACCU: "/participant-web-services/rest/nonauth/resetAccu/{accu}",
    SET_ACCU: "/participant-web-services/rest/nonauth/setAccu/{accu}",
    GET_USERNAME_API: "/participant-web-services/rest/partialauth/getUsername",
    RESET_ACCOUNT_API: "/participant-web-services/rest/partialauth/resetPassword",
    VERIFY_CODE: "/participant-web-services/rest/partialauth/mfa/verifycode",
    VERIFY_CODE_BY_IND_ID_DB_NAME:
        "/participant-web-services/rest/partialauth/mfa/verifycodeByIndIdDbName",
    CREATE_AND_DELIVER_ACTIVATION_CODE:
        "/participant-web-services/rest/partialauth/mfa/createAndDeliverActivationCode",
    GET_STATE_CODE: "/participant-web-services/rest/nonauth/util/stateCodes",
    GET_COUNTRY_CODE: "/participant-web-services/rest/nonauth/util/countryCodes",
    GET_EXISTING_USER_OTS: "/participant-web-services/rest/nonauth/authenticateOtsUser",
    CREATE_SHADOW_ACCOUNT_OTS: "/participant-web-services/rest/partialauth/ots/shadowAccount",
    CREATE_AND_DELIVER_ACTIVATION_CODE_BY_IND_ID:
        "/participant-web-services/rest/partialauth/mfa/createAndDeliverActivationCodePostByIndId",
    SET_SPANISH_LANGUAGE_COOKIES:
        "/participant-web-services/rest/partialauth/profile/setSpnLangCookies",
    GET_LEGACY_SSO_AUTH_TOKEN:
        "/participant-web-services/rest/sso/retrieveLegSSOAuthToken/indId/{indId}/group/{gaId}",
    GROUP_TXN_ACCESS:
        "/participant-web-services/rest/groupTxnAccess/{individualId}/{groupId}/txnCodes/{txnCode}",
    GET_BENEFICIARIES: "/participant-web-services/rest/beneficiary/getBeneficiaries",
    RETRIVE_IDPROOF_QUESTIONS:
        "/participant-web-services/rest/partialauth/idProof/retrieveIDProofingData",
    SUBMIT_IDPROOF_QUESTIONS:
        "/participant-web-services/rest/partialauth/idProof/submitIDProofData",
    hideLoginPatterns: [
        /\/docs\/broker-check/,
        /\/docs\/business-continuity/,
        /\/docs\/excessive-trading/,
        /\/docs\/privacy/,
        /\/docs\/security/,
        /\/docs\/terms-and-conditions/
    ],
    hideLoginBeforeAuthPatterns: [
        /\/accessDeniedError/,
        /\/account-recovery/,
        /\/account-selection/,
        /\/account-setup/,
        /\/accountOpenDetails/,
        /\/accountOpenPersonalDetails/,
        /\/articles/,
        /\/change-personal-contact/,
        /\/choose-primaryplan/,
        /\/contact-update/,
        /\/csrfAccessDeniedError/,
        /\/force-change-password/,
        /\/generic-error/,
        /\/linkable-plans/,
        /\/linked-confirmation/,
        /\/loginHelp/,
        /\/mfa/,
        /\/npdi/,
        /\/oauth/,
        /\/oneIdMfaActivationCode/,
        /\/oneIdMfaEnterCode/,
        /\/openAnAccount/,
        /\/otp-verify/,
        /\/idProofWithPin/,
        /\/idProofError/,
        /\/idProofQueries/,
        /\/mailPin/,
        /\/profile/,
        /\/register/,
        /\/register-info/,
        /\/register\/group/,
        /\/register\/pin/,
        /\/registration-summary/,
        /\/versions/,
        /\/eConsent\/change-Comm-Pref/,
        /\/re-enroll/,
        /\/paeSSOlanding/,
        /\/ssoSpinner/,
        /\/mobileSSO/,
        /\/inboundSSO/,
        /\/iraTerms/
    ],
    DEFAULT_STALE_TIME: 300000, // 5 minutes
    QUERY_KEYS: {
        TRANSLATIONS: "translations"
    },
    supportedACCU:
        "3M,AAH,ACNA,AENetworks,AEP,AJG,AOC,ASD,AbbVie,AcecrtWR,Adventist,AlabamaWR,AlamedaCounty,AlaskaWR,AmFam,AmFunds,AmWater,Amcor,AnchorageWR,Apple,ArvadaWR,AssuredPartners,AuroraWR,AustinWR,BAE,BBraun,BMGF,BMO,BNAT,BSWH,BTAmericas,BakerHughes,BarclaysWR,Bechtel,BellinHealth,Bloomberg,BoydGaming,Brenntag,CCAOWR,CDPHP,CECWR,CFG,CHCO,CHLA,CLA,COJ,COPERA,CPSWR,CTA,CTDCP,CWA,CaesarsEnt,CarolinasHCS,CcoeraWR,ChesterFldWR,ChugachWR,Cigna,CityOfMemphis,CityOfMesaWR,ClarkCounty,Connecticut,ContraCosta,Corewell,Corning,CountyOfLA,Cubic,DAPWR,DMBAWR,DawnFoods,Default,DefaultWithNav,DollarTree,Duly,EDJ,EMCI,Elliot,Empower,EmpowerNQE,EmpowerSPC,EmpowerStaff,EmpowerTH,Evonik,FairfaxWR,Ferguson,FifthThirdBnk,FifthThirdWR,FujiFilm,FultonCounty,GFUS,GHC,GMR,Goodyear,Guam,HCSC,HLMCC,HUB,Hallmark,Hawaii,Hilti,HonorHealth,HoustonWR,IBEW8,ICON,IP,IRAWR,ITWWR,IUEC,IWWPA,IdahoWR,Illinois,IndianaWR,IntuitWR,Iowa,JBSWR,JIBEI,JPM,JPMC,JackHenry,Jennison,JerseyCity,KansasWR,KonicaMinolta,LMC,Lear,Legrand,Lennar,Lifepoint,LouisianaWR,MGM,MRE,MTA,MUFG,MWD,MYERIRA,MassCoreWR,Massachusetts,McDonalds,MedStarHealth,MercerWise,MercyHealth,MetLifeEE,MilwaukeeWR,MinnesotaWR,MississippiWR,MontanaWR,Montgomery,MultiCare,NADAWR,NAPAM,NEFP,NJHE,NJRP,NPPD,NYCB,NYCHH,NYCWR,NYL,NYP,NassauCounty,NebraskaMed,NewHampshire,NewJerseyWR,NonQual,NorthCarolina,OPEIU,OaklandCounty,OklahomaWR,OldDominion,OrangeCntyWR,Oshkosh,PENN,PasadenaWR,PathfinderWR,Pearson,PennState,Pennsylvania,Philips,PrismaHealth,Pru,PutnamStaff,RBS,RELX,RTS,Reyes,Richs,RiteAid,RocklandCnty,Rollins,RussellInv,SCORP,SEPTA,SIA,SWA,SWCarpenters,SanDiegoWR,SanMateo,SantaAnaWR,SantaBarbara,SantanderBnk,Schneider,SedgwickWR,Signet,Silgan,Skadden,Smithfield,Solventum,Sonoco,SouthCarolina,Staples,Stifel,SunTrustEE,SymantecWR,TE,Taft,TallahasseeWR,TeamstersNtl,TeamstersUPS,TennesseeWR,Test,TexasWR,Thrivent,Tiffany,TorranceWR,TraderJoes,TreeHouse,TriNet,TriNetSelect,Tucson,UA1,UCHealth,UKG,UMMS,UPhoenix,USW,UUA,VSP,VailWR,VeritasWR,Vermont,Viacom,Volvo,Vulcan,WD,WVTeachersWR,WVirginiaWR,Walgreens,WayneCounty,WellSpanWR,WellsFargo,WestRock,Westchester,WhiteCaseSIP,WisconsinWR,WyomingWR",
    NPDI: {
        RETRIEVE_DROPDOWN_VALUES: "rest/nonauth/npdi/retrieveDropdownValuesOnNpdiPageLoad",
        VALIDATE_PPT_DATA: "rest/nonauth/npdi/validatePPTDataWithNPDI",
        RETRIEVE_CONTACT_DETAILS: "rest/nonauth/npdi/retrieveContactDetailsDropdown",
        ADD_NPDI_PPT: "rest/nonauth/npdi/addNPDIPPTEnroll",
        RETRIEVE_PLANS: "rest/nonauth/npdi/npdiLinkedPlans",
        PEC_KTMG_ENABLED: "rest/nonauth/npdi/isPECKTMGEnabled",
        UPD_NPDI_ENROLL: "rest/nonauth/npdi/updNPDIPPTEnroll"
    },
    ACCOUNT_SETUP: {
        RETRIEVE_CONTACT_DETAILS: "rest/partialauth/retrieveContactDetails",
        UPDATE_CONTACT: "rest/partialauth/contactInformation/updateContact",
        REGISTER_USER: "rest/partialauth/contactInformation/registerUser"
    },
    /**
     * Values for HTTP content type.
     */
    HTTP_METHOD: {
        GET: "get",
        POST: "post",
        PUT: "put",
        DELETE: "delete",
        PATCH: "patch"
    },

    /**
     * Values for HTTP content type.
     */
    HTTP_CONTENT_TYPE: {
        URL_ENCODED: "application/x-www-form-urlencoded",
        JSON: "application/json"
    }
};

export default ReferenceData;
